export default __webpack_public_path__ + "static/Waterfront-Park1920px-34fd34e311d544c6de78c11a944855d4.jpg";